import { useAuth } from '../contexts/authContext';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { GetUsersPerActivity, GetUsersPerDayAndMonthStatistics } from '../features/moderatorUserTracking/services/moderatorService';
import { UsersPerActivityChart } from '../features/moderatorUserTracking/components/UsersPerActivityChart';
import { UsersPerDayAndMonthChart} from '../features/moderatorUserTracking/components/UsersPerDayAndMonthChart';
import { UsersPerActivityTable } from '../features/moderatorUserTracking/components/UsersPerActivityTable';
import { UsersPerDayAndMonthTable } from '../features/moderatorUserTracking/components/UsersPerDayAndMonthTable';
import { useSnackbar } from 'notistack';
import { Grid, Button, Box } from '@mui/material';


export default function ModeratorStatisticsPage () {
  const auth = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [statisticsData, setStatisticsData] = useState({ isFetching: true, statistics: [] });
  const [statisticsByDayAndMonthData, setStatisticsByDayAndMonthData] = useState({ isFetching: true, statisticsDayAndMonth: [] });
  const [view, setView] = useState('chart');

  useEffect(() => {
    const fetchData = async (showSuccesMsg = true, showErrorMsg = true) => {
      try {
        const statistics = await GetUsersPerActivity(auth.user.id);
        if (showSuccesMsg) enqueueSnackbar(<FormattedMessage id='trainings.get.msg.success' defaultMessage='Trainings successfully fetched' />, {
          variant: 'success',
        });
        setStatisticsData({ isFetching: false, statistics });
      } catch (error) {
        if (showErrorMsg) enqueueSnackbar(<FormattedMessage id='trainings.get.msg.error' defaultMessage='Trainings fetch failed' />, {
          variant: 'error',
        });
        setStatisticsData({ isFetching: false, statistics: [] });
      }
    };

    const fetchSecondEndpointData = async () => {
      try {
        const statisticsDayAndMonth = await GetUsersPerDayAndMonthStatistics(auth.user.id);
        setStatisticsByDayAndMonthData({ isFetching: false, statisticsDayAndMonth });
      } catch (error) {
        console.error('Error fetching data from the second endpoint:', error);
        setStatisticsByDayAndMonthData({ isFetching: false, statisticsDayAndMonth: [] });
      }
    };

    fetchData();
    fetchSecondEndpointData();
  }, [auth.user.id, enqueueSnackbar]);

  const handleViewChange = (newView) => {
    setView(newView);
  };
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center" mb={2}>
          <Button
            variant={view === 'chart' ? 'contained' : 'outlined'}
            onClick={() => handleViewChange('chart')}
            style={{ marginRight: '8px' }}
          >
            <FormattedMessage id='moderatorUserTracking.button.graph' defaultMessage='SHOW GRAPH' />
          </Button>
          <Button
            variant={view === 'table' ? 'contained' : 'outlined'}
            onClick={() => handleViewChange('table')}
            style={{ marginLeft: '8px' }}
          >
            <FormattedMessage id='moderatorUserTracking.button.table' defaultMessage='SHOW TABLE' />
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12}>
        {view === 'chart' ? (
          <>
            <UsersPerActivityChart data={statisticsData.statistics} />
            <UsersPerDayAndMonthChart data={statisticsByDayAndMonthData.statisticsDayAndMonth} />
          </>
        ) : (
          <>
            <UsersPerActivityTable data={statisticsData.statistics} />
            <Box sx={{ my: 2 }} />
            <UsersPerDayAndMonthTable data={statisticsByDayAndMonthData.statisticsDayAndMonth} />
          </>
        )}
      </Grid>
    </Grid>
  );
}